import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20unboxing%20scene%20with%20premium%20packaging%20box%2C%20tissue%20paper%2C%20designer%20fashion%20items%20spilling%20out%2C%20warm%20golden%20hour%20lighting%20from%20side%20window%2C%20soft%20cream%20and%20beige%20tones%2C%20minimalist%20clean%20background%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%20and%20elegant%20composition&width=1600&height=700&seq=gtbuy-cta-lifestyle&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-black/25" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Ready to Start Shopping Smarter?
        </h2>
        <p className="text-sm md:text-lg text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
          Join thousands of shoppers using GTBuy Spreadsheet to manage their purchases efficiently. Get started today and experience organized shopping.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-foreground-900 rounded-full text-sm md:text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Visit GTBuy Sheet
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line"></i></span>
          </a>
          <Link
            to="/article/what-is-gtbuy-spreadsheet"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white/20 text-white border border-white/30 rounded-full text-sm md:text-base font-medium hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
          >
            Read the Full Guide
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-book-open-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
}